import _pt from "prop-types";
import React from 'react';
import PrivacySettingsLink from './PrivacySettingsLink';
import languages from './languages';
var inlineLiClasses = 'hc-c-footer__inline-item';
/**
 * Create <li> nodes and inline links
 */

var renderBasicList = function renderBasicList(t, links) {
  return Object.getOwnPropertyNames(links).map(function (key, index) {
    var link = typeof links[key] === 'string' ? /*#__PURE__*/React.createElement("a", {
      href: links[key]
    }, t(key)) : links[key];
    return /*#__PURE__*/React.createElement("li", {
      key: key,
      className: inlineLiClasses
    }, link, index !== Object.getOwnPropertyNames(links).length - 1 ? /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true",
      className: "hc-c-footer__delimiter"
    }) : null);
  });
};
/**
 * Inline link lists are always rendered in the footer, no matter
 * what type of page a user is looking at. It includes required
 * links, like the Privacy Policy, and other helpful things like
 * links to a variety of different languages.
 */


var InlineLinkLists = function InlineLinkLists(props) {
  var primaryDomain = props.primaryDomain;
  var inlineLinksTop = {
    'footer.contactUs': "".concat(primaryDomain, "/contact-us"),
    'footer.archive': "".concat(primaryDomain, "/archive"),
    'footer.a11y': 'http://www.cms.gov/About-CMS/Agency-Information/Aboutwebsite/CMSNondiscriminationNotice.html',
    'footer.privacySettings': /*#__PURE__*/React.createElement(PrivacySettingsLink, null),
    'footer.privacyPolicy': "".concat(primaryDomain, "/privacy"),
    'footer.usingThisSite': "".concat(primaryDomain, "/using-this-site")
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "ds-l-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hc-c-footer__site-links-row"
  }, /*#__PURE__*/React.createElement("ul", {
    role: "list",
    className: "hc-c-footer__list"
  }, renderBasicList(props.t, inlineLinksTop))), /*#__PURE__*/React.createElement("div", {
    className: "hc-c-footer__language-resource-links-row"
  }, /*#__PURE__*/React.createElement("h4", {
    id: "global-footer-language-resources",
    className: "ds-u-visibility--screen-reader"
  }, "Language resources"), /*#__PURE__*/React.createElement("ul", {
    role: "list",
    "aria-labelledby": "global-footer-language-resources",
    className: "hc-c-footer__list"
  }, Object.getOwnPropertyNames(languages).map(function (lang, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: lang,
      className: inlineLiClasses
    }, /*#__PURE__*/React.createElement("a", {
      lang: lang,
      href: primaryDomain + languages[lang].href
    }, languages[lang].label));
  }))));
};

InlineLinkLists.propTypes = {
  primaryDomain: _pt.string
};
InlineLinkLists.defaultProps = {
  primaryDomain: ''
};
export default InlineLinkLists;